import { render } from "./CustomerDetail.vue?vue&type=template&id=2a72c22a&scoped=true&ts=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts"

import "./CustomerDetail.vue?vue&type=style&index=0&id=2a72c22a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a72c22a"]])

export default __exports__